import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { VrCommonModule } from '../../vr-common.module';
import { VrcInputComponent } from './vrc-input.component';

import { IMaskModule } from 'angular-imask';

const exports = [VrcInputComponent];

@NgModule({
  declarations: [...exports],
  exports,
  imports: [
    CommonModule,
    VrCommonModule,
    FormsModule,
    IMaskModule,
    ReactiveFormsModule
  ]
})
export class VrcInputModule { }
